import styles from "./stepper.module.scss";

interface StepperProps {
  count: number;
  current: number;
}

export function Stepper({ count, current }: StepperProps) {
  return (
    <ol className={styles.container}>
      {Array.from({ length: count }, (_, i) => (
        <li
          key={i}
          className={`${styles.step}${current <= i ? ` ${styles.stepInactive}` : ""}`}
        />
      ))}
    </ol>
  );
}
